import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WorkspaceWithNoReportsDto } from 'api/NSwagApi/api';

interface State {
	refreshWorkspace:boolean;
    dataLoaded: boolean;
	workspaceListData: WorkspaceWithNoReportsDto[]
}

const initialState: State = {
	dataLoaded: false,
	refreshWorkspace: false,
	workspaceListData: []
};

const workspacesSlice = createSlice({
	initialState,
	name: 'workspaces',
	reducers: {
		refreshWorkspace: (
			state,
			action: PayloadAction<boolean>
		) => {
			if (action.payload) {
				state.refreshWorkspace = action.payload;
			}
		},
		workspaceListData: (
			state,
			action: PayloadAction<WorkspaceWithNoReportsDto[]>
		) => {
			if (action.payload) {
				state.workspaceListData = action.payload;
			}
		},
		setWorkspacesDataLoadedFlag: (
			state,
			action: PayloadAction<boolean>
		) => {
			state.dataLoaded = action.payload;
		},
		workspacesReset: () => initialState
	},
});

export const { refreshWorkspace, workspacesReset, workspaceListData } = workspacesSlice.actions;
export default workspacesSlice.reducer;